import { Box } from '@chakra-ui/react';
import VFormFieldHorizontal from '@voly/ui-components/src/v2/VFormFieldHorizontal';
import VInput from '@voly/ui-components/src/v2/VInput.jsx';
import VTooltip from '@voly/ui-components/src/v2/VTooltip';
import { ReactElement } from 'react';
import { translate } from 'src/app/project/features/translate/translate';
import {
  TCustomField,
  TWorkspaceCustomFields,
} from 'src/app/project/modules/custom-fields/custom-fields.model';
import PointFieldName from './PointFieldName';
import { parseNumericValue } from '../../../utils/numericValue';
import UnitNumberInput from '../UnitNumberInput';
import FormulaTooltip from './FormulaTooltip';
import { getNumericFormat } from './numericFieldFormat';

const MIN_VALUE = Number.MIN_SAFE_INTEGER;

interface PointFieldFormulaProps {
  field: TCustomField;
  value: string | null | undefined;
  customFields?: TWorkspaceCustomFields;
}

const PointFieldFormula = ({
  field,
  value,
  customFields = {},
}: PointFieldFormulaProps): ReactElement => {
  const result = parseNumericValue(value);
  const { unit, decimalPlaces, useGrouping } = getNumericFormat(field, field.outputType);

  return (
    <VFormFieldHorizontal
      data-testid="point-custom-field-row"
      size="sm"
      label={<PointFieldName field={field} />}
      helperText={field.description}
      errorText={undefined}
      invalid={undefined}
      disabled
    >
      <VTooltip
        content={<FormulaTooltip formula={field.formula ?? ''} customFields={customFields} />}
        disabled={!field.formula}
      >
        <Box data-testid="point-custom-field-control">
          {result === null ? (
            <VInput width="100%" size="sm" value={translate('unable_to_calculate_formula')} />
          ) : (
            <UnitNumberInput
              value={result}
              min={MIN_VALUE}
              unit={unit}
              size="sm"
              textAlign="end"
              formatOptions={{
                minimumFractionDigits: decimalPlaces,
                maximumFractionDigits: decimalPlaces,
                useGrouping,
              }}
              onValueChange={() => undefined}
            />
          )}
        </Box>
      </VTooltip>
    </VFormFieldHorizontal>
  );
};

export default PointFieldFormula;
